
import { reactive, ref } from "vue";
import useMainStore from '../stores/main.store';
import * as VMask from "vanilla-masker";

class ContactComponent {
  fields = reactive({ email: '', firstName: '', phone: '(02) 4297 0037', lastName: '' });
  validate = reactive({ email: false, firstName: false, phone: false, lastName: false });
  isEnabled = ref(false);


  validateEmail() {
    const regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/g;
    this.validate.email = regex.test(this.fields.email);
    this.validateEmpty();
    this.activeNextStep();
  }

  validatePhone() {
    const regex = /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/;
    this.validate.phone = regex.test(this.fields.phone);
    this.activeNextStep();
    this.validateEmpty();
  }

  maskPhone() {
    console.log(this.fields.phone);
    this.fields.phone = VMask.toPattern(this.fields.phone, '(99) 9999 9999').trim();
    this.validatePhone();
  }

  validateHumanName() {
    const regex = /^[a-zA-Z\-\'\s]+$/;
    this.fields.firstName = this.fields.firstName.replace(/[^A-Za-z\s_'-]/gi, '');
    this.fields.lastName = this.fields.lastName.replace(/[^A-Za-z\s_'-]/gi, '');
    this.fields.lastName = this._capitalizeFirstLetter(this.fields.lastName);
    this.fields.firstName = this._capitalizeFirstLetter(this.fields.firstName);
    this.validate.lastName = regex.test(this.fields.lastName);
    this.validate.firstName = regex.test(this.fields.firstName);
    this.activeNextStep();
  }

  activeNextStep() {
    this.isEnabled.value = Object.values(this.validate).reduce(
      (accumulator, currentValue) => accumulator && currentValue, true
    );
    this.store();
    // console.log('active next step: ', this.isEnabled.value);
  }

  _capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }


  validateEmpty() {
    this.isEnabled.value = Object.values(this.fields).reduce((accumulator, currentValue) => accumulator && currentValue.length > 0, true);
    this.store();
    // console.log('next btn is Enabled: ', this.isEnabled.value);
  }

  store() {
    const store = useMainStore();
    store.$state.valid = this.isEnabled.value;
    for (const key of Object.keys(this.fields)) {
      if (this.validate[key]) {
        store.store(key, this.fields[key]);
      }
    }
  }

  // send() {
  //   const companyStore = useCompanyStore();
  //   (new HttpClient()).post('/plan', companyStore.getAll())
  // }
}

export default new ContactComponent;